import './App.css';
import formsDGT from './forms_dgt.json';
import provincias from './provincias.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {Checkbox, Input, MenuItem, Select, Button, NativeSelectRoot, NativeSelectField} from "@chakra-ui/react";
import * as React from 'react'

export default function Success() {
    return (
        <div>
            <h1>Formulario enviado, ya puedes regresar a Telegram</h1>
        </div>
    );
};